import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67faef13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown app-drawer" }
const _hoisted_2 = {
  type: "button",
  class: "btn btn-icon btn-outline-primary d-flex align-items-center",
  "data-bs-toggle": "dropdown",
  "data-bs-display": "static",
  "aria-expanded": "false"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-2" }, "apps", -1))
const _hoisted_4 = { class: "dropdown-menu dropdown-menu-end p-3" }
const _hoisted_5 = { class: "drawer-title text-uppercase fw-700 mb-2" }
const _hoisted_6 = { class: "d-grid gap-2" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "app-chooser-text" }
const _hoisted_9 = { class: "app-chooser-title" }
const _hoisted_10 = { class: "app-chooser-desc" }
const _hoisted_11 = {
  key: 0,
  class: "app-chooser-chevron"
}
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(_toDisplayString(_ctx.$t("apps.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("apps.title")), 1),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorizedApps, (app) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isCurrentApp(app) ? 'span' : 'a'), {
            key: app.code,
            href: _ctx.isCurrentApp(app) ? null : app.url,
            target: _ctx.isCurrentApp(app) ? null : '_blank',
            class: _normalizeClass(["app-chooser-btn d-flex align-items-center text-decoration-none", { current: _ctx.isCurrentApp(app) }])
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(["app-chooser-icon", 'app-chooser-icon--' + app.variant])
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/apps/' + app.icon + '.svg'),
                  alt: _ctx.appTitle(app),
                  width: "20",
                  height: "20"
                }, null, 8, _hoisted_7)
              ], 2),
              _createElementVNode("span", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.appTitle(app)), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.appDescription(app)), 1)
              ]),
              (!_ctx.isCurrentApp(app))
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createElementVNode("img", {
                      src: require('@/assets/images/apps/chevron.svg'),
                      alt: "",
                      width: "14",
                      height: "14"
                    }, null, 8, _hoisted_12)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["href", "target", "class"]))
        }), 128))
      ])
    ])
  ]))
}